// // frontend/src/services/recommendationService.ts
import { Recipe } from '@/types';
import { apiClient } from './api';

// export const recommendationService = {
//   async getPersonalizedRecommendations(token: string, limit: number = 10): Promise<Recipe[]> {
//     const response = await apiClient.get(`/recommendations/personalized?limit=${limit}`, token);
//     return response;
//   },

//   async getBreakfastRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
//     const response = await apiClient.get(`/recommendations/breakfast?limit=${limit}`, token);
//     return response.data;
//   },

//   async getLunchRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
//     const response = await apiClient.get(`/recommendations/lunch?limit=${limit}`, token);
//     return response.data;
//   },

//   async getDinnerRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
//     const response = await apiClient.get(`/recommendations/dinner?limit=${limit}`, token);
//     return response.data;
//   },

//   async getSnackRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
//     const response = await apiClient.get(`/recommendations/snack?limit=${limit}`, token);
//     return response.data;
//   }
// };
// frontend/src/services/recommendationService.ts
export const recommendationService = {
  async getPersonalizedRecommendations(token: string, limit: number = 10): Promise<Recipe[]> {
    try {
      console.log('📡 Fetching personalized recommendations...');
      const response = await apiClient.get(`/recommendations/personalized?limit=${limit}`, token);

      // DEBUG: Verifica la estructura de la respuesta
      console.log('🔍 Response structure:', response);
      console.log('📊 Is array?', Array.isArray(response));
      console.log('📦 Response keys:', response ? Object.keys(response) : 'null');

      // Si response es directamente el array, devuélvelo
      if (Array.isArray(response)) {
        console.log('✅ Recommendations received as array:', response.length, 'recipes');
        return response;
      }

      // Si response tiene propiedad data que es array
      if (response && response.data && Array.isArray(response.data)) {
        console.log('✅ Recommendations received in data property:', response.data.length, 'recipes');
        return response.data;
      }

      console.warn('⚠️ Unexpected response format:', response);
      return [];

    } catch (error) {
      console.error('❌ Error fetching recommendations:', error);
      throw error;
    }
  },

  // Los otros métodos mantienen .data ya que están comentados por ahora
  async getBreakfastRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
    const response = await apiClient.get(`/recommendations/breakfast?limit=${limit}`, token);
    return response.data;
  },

  async getLunchRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
    const response = await apiClient.get(`/recommendations/lunch?limit=${limit}`, token);
    return response.data;
  },

  async getDinnerRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
    const response = await apiClient.get(`/recommendations/dinner?limit=${limit}`, token);
    return response.data;
  },

  async getSnackRecommendations(token: string, limit: number = 5): Promise<Recipe[]> {
    const response = await apiClient.get(`/recommendations/snack?limit=${limit}`, token);
    return response.data;
  }
};